import { TEACHER_DASHBOARD_NAVIGATION_IDS } from "./teacherDashboardNavigation";

export const DEFAULT_REPORTING_CONFIGURATION = {
  [TEACHER_DASHBOARD_NAVIGATION_IDS.REPORTING]: {
    title: "Reporting",
    subheading:
      "Use these tools to understand the children joining your class and to continue recording observations as they progress through the year.",
  },
  [TEACHER_DASHBOARD_NAVIGATION_IDS.NEW_CLASS_INSIGHTS]: {
    title: "New Class Insights",
    subheading:
      "Summarises a pupil's transition into the current class using the saved End of Year report from ALPACA and staff notes from the previous school year.",
  },
  [TEACHER_DASHBOARD_NAVIGATION_IDS.SCREENING_POINT_REPORT]: {
    title: "Screening Point Report",
    subheading:
      "Generate a report for a single screening point, using the pupil's completed screener for that point.",
  },
  [TEACHER_DASHBOARD_NAVIGATION_IDS.PARENT_TEACHER_MEETING]: {
    title: "Parent Teacher Meeting",
    subheading:
      "Generate a parent-facing handout for a PTM, using the pupil's completed screeners for the year.",
  },
  [TEACHER_DASHBOARD_NAVIGATION_IDS.EOY_REPORT_ASSISTANT]: {
    title: "End of Year Report Assistance",
    subheading:
      "Generate or review End-of-Year reports from the previous school year.",
  },
  [TEACHER_DASHBOARD_NAVIGATION_IDS.CLASSROOM_HANDOVER]: {
    title: "Classroom Observations",
    subheading:
      "Review and continue recording classroom observations for pupils in your class.",
  },
};

export const REPORTING_CONFIGURATION_IDS = Object.keys(
  DEFAULT_REPORTING_CONFIGURATION
);
